import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=9c7a323e&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7a323e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7a323e')) {
      api.createRecord('9c7a323e', component.options)
    } else {
      api.reload('9c7a323e', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=9c7a323e&scoped=true&", function () {
      api.rerender('9c7a323e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/upload.vue"
export default component.exports